import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// import: styles
// import: assets
// import: config
// import: constants
import { APP, STUDIO } from 'core/navigation/Routes';

// import: utils
// import: services
// import: redux
// import: components
// import: lazy load components

function CanvasRedirectOldRouteToNewRoute() {
	const { canvasId } = useParams();

	return <Navigate to={`/${APP}/${STUDIO}/${canvasId}`} replace />;
}

export default CanvasRedirectOldRouteToNewRoute;
